import { useState, useEffect, useRef } from "react";
import {
  useEmailSchedule,
  EmailScheduleDTO,
} from "pages/reports/bi-dashboard-next/hooks/useEmailSchedule";
import { ReportDTO } from "pages/reports/bi-dashboard-next/models/ReportDTO";

interface UseReportScheduleModalsProps {
  reportId: number;
  title: string;
  description: string;
  reportNumber?: string;
  emailScheduleCount?: number;
}

export const useReportScheduleModals = ({
  reportId,
  title,
  description,
  reportNumber = "",
  emailScheduleCount = 0,
}: UseReportScheduleModalsProps) => {
  const { getSchedules, isLoading } = useEmailSchedule();

  const [showSelectScheduleModal, setShowSelectScheduleModal] = useState(false);
  const [showEmailScheduleModal, setShowEmailScheduleModal] = useState(false);
  const [showEmailReportModal, setShowEmailReportModal] = useState(false);

  const [schedules, setSchedules] = useState<EmailScheduleDTO[]>([]);
  const [selectedSchedule, setSelectedSchedule] =
    useState<EmailScheduleDTO | null>(null);

  const hasCheckedForSchedules = useRef<boolean>(false);

  const reportObject: ReportDTO = {
    id: reportId,
    reportNumber,
    name: title,
    details: description,
    enabled: true,
    createdAt: "",
    updatedAt: "",
    reportUpdatedAt: "",
    privateUserId: "",
    createdActorId: "",
    source: "",
    originalReportName: "",
    createFilterSet: false,
    tags: [],
    favorited: false,
    emailScheduleCount,
  };

  useEffect(() => {
    hasCheckedForSchedules.current = false;
  }, [reportId]);

  useEffect(() => {
    if (showSelectScheduleModal && !hasCheckedForSchedules.current) {
      const fetchSchedules = async () => {
        const fetchedSchedules = await getSchedules(reportObject);
        setSchedules(fetchedSchedules);
        hasCheckedForSchedules.current = true;
      };

      fetchSchedules();
    }
  }, [showSelectScheduleModal, reportObject, getSchedules]);

  const handleShowScheduleModal = () => {
    if (emailScheduleCount > 0) {
      setShowSelectScheduleModal(true);
    } else {
      setShowEmailScheduleModal(true);
    }
  };

  const handleShowCreateScheduleModal = () => {
    setShowSelectScheduleModal(false);
    setSelectedSchedule(null);
    setShowEmailScheduleModal(true);
  };

  const handleShowUpdateScheduleModal = (schedule: EmailScheduleDTO) => {
    setShowSelectScheduleModal(false);
    setSelectedSchedule(schedule);
    setShowEmailScheduleModal(true);
  };

  return {
    showSelectScheduleModal,
    setShowSelectScheduleModal,
    showEmailScheduleModal,
    setShowEmailScheduleModal,
    showEmailReportModal,
    setShowEmailReportModal,

    schedules,
    selectedSchedule,
    isLoading,

    reportObject,

    handleShowScheduleModal,
    handleShowCreateScheduleModal,
    handleShowUpdateScheduleModal,
  };
};
